import IFrame from '../components/Iframe';

const PostIncorporationService = () => {
  return (
    <div className='w-[100vw] h-[100vh] p-[20px] bg-[white]'>
      <IFrame
        link='https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fsterlingbank.eu.qualtrics.com%2Fjfe%2Fform%2FSV_cOz9eHMAPdFkd0i&data=05%7C01%7CUfuoma.Afe%40sterling.ng%7C0dc21cb530ec46469ad808dbba948e3c%7C4c8a9f7a11fc4fc290990b68f72a197e%7C0%7C0%7C638308919477204353%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=XdlMAUMHJpUxSOSxrmi2eXhHoEunSoi6c1DPcz8%2FoYs%3D&reserved=0'
        className='w-full h-full relative z-20'
        title='post incorporation service'
      />
    </div>
  );
};

export default PostIncorporationService;
